import React, { useState } from "react";
import "./WelcomePage.css";
import vendorimg from "../../../assets/Component 24.png";
import finkraft from "../../../assets/finkraft.png";
import axios from "axios"; // Make sure to install axios
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const WelcomePage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleContinue = async () => {
    if (!email) {
      setError("Enter a valid email address.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post("https://vendor-score.finkraftai.com/mxlookup", {
        domain: email,
      });

      if (response.data?.mx_records?.length > 0) {
        navigate("/signup", { state: { email } });
      } else {
        setError("Enter a valid email address.");
      }
    } catch (err) {
      const errorMessage = "Enter a valid email address" 
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-main">
      <div className="login-container">
        <div className="logo">
          <img src={finkraft} alt="Logo" className="logo-img" />
        </div>

        <div className="login-box">
          <h1 className="welcome-text">Welcome to Vendor Score</h1>
          <p className="subtext">Please enter your email address to begin.</p>

          <label className="label">Email Address</label>
          <div className="input-wrapper">
            <input
              type="email"
              placeholder="Enter email address"
              className="input"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError(""); // Clear error on typing
              }}
            />
             {loading && (
    <div className="loader-container">
      <div className="loader-spinner" />
    </div>
  )}
          </div>
          {error && <p className="error-msg">{error}</p>}

          <button className="continue-button" onClick={handleContinue}>Continue</button>

          <p className="signup-text">
            Already have an account? <Link to="/login">Log in.</Link>
          </p>
        </div>
      </div>

      <div className="vendor-image-container">
        <img src={vendorimg} className="vendor-image" />
      </div>
    </div>
  );
};

export default WelcomePage;
